import type { InboxCategory, InboxSort } from "./kinds";

export const INBOX_PAGE_SIZE = 20;

export type InboxQueryVariables = {
  filter: {
    category: InboxCategory;
    routeIds?: string[];
    teamIds?: string[];
    sort?: InboxSort;
  };
  paging: { offset?: number; after?: string; limit?: number };
};

export const inboxQueryVariables = ({
  category = "EVERYTHING",
  routeId = null,
  routeIds,
  teamId = null,
  teamIds,
  sort,
  offset = 0,
  limit,
  after,
}: {
  category?: InboxCategory;
  routeId?: string | null;
  routeIds?: readonly string[] | null;
  teamId?: string | null;
  teamIds?: readonly string[] | null;
  sort?: InboxSort | null;
  offset?: number;
  limit?: number;
  after?: string;
} = {}): InboxQueryVariables => {
  const ids = routeIds ?? (routeId ? [routeId] : undefined);
  const teams = teamIds ?? (teamId ? [teamId] : undefined);
  return {
    filter: {
      category,
      ...(ids && ids.length > 0 ? { routeIds: [...ids] } : {}),
      ...(teams && teams.length > 0 ? { teamIds: [...teams] } : {}),
      ...(sort === "NEWEST" ? { sort: "NEWEST" } : {}),
    },
    paging: after
      ? { after, ...(limit != null ? { limit } : {}) }
      : { offset, ...(limit != null ? { limit } : {}) },
  };
};

/** Page from the wire rows, not the parsed list, so a dropped kind cannot stick Load more. */
export const inboxRawPage = (
  rows: readonly { id: string }[],
  total: number,
  pageSize?: number
): { hasMore: boolean; after: string | undefined } => ({
  hasMore: pageSize != null && rows.length < total,
  after: rows.at(-1)?.id,
});
